import { Injectable } from '@angular/core';

import {environment} from '../../../environments/environment';
import {AuthService} from './auth.service';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class WebSocketService {

    private socket: WebSocket;
    private connected: boolean = false;
    public message: Subject<Object>;
    constructor() {
        this.message = new Subject();
    }

    connectClient(email: string): void{

        this.socket = new WebSocket(environment.nodejs_url);
        this.connected = true;
        this.socket.onopen = () => {
            this.socket.send(JSON.stringify({ 'email' : email, 'operation' : 'add'}));
        };

        this.socket.onmessage = (e) => {
            let data = JSON.parse(e.data);
            this.message.next(data);
        }
    }

    close(email: string): void{
        if(this.isConnected()){
            this.socket.send(JSON.stringify({'email' : email, 'operation' : 'remove'}));
            this.socket.close();
            this.connected = false;
        }
    }

    isConnected(): boolean {
        return this.connected;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/service/web-socket-service.ts